import { animate, style, transition, trigger } from '@angular/animations'
import { Component, input, output } from '@angular/core'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'

import { AiLoadingSpinnerComponent } from '../../components/ai-loading-spinner/ai-loading-spinner.component'

@Component({
  selector: 'flx-ai-pending-message',
  imports: [FlxIconModule, AiLoadingSpinnerComponent],
  templateUrl: './ai-pending-message.component.html',
  styleUrl: './ai-pending-message.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':leave', [animate('300ms ease-out', style({ transform: 'translateY(-100%)' }))]),
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class AiPendingMessageComponent {
  message = input<string>()
  status = input<string>()

  cancelPendingRequest = output()
}
